import styled from "styled-components";
import { Color, ColorDark, Font, breakpoints } from "@/shared/Constants";

export const CommentaryWidgetContainer = styled.div`
  width: 100%;
  position: relative;
  margin: 30px 0;

  hr {
    margin: 0;
    border: 0 none;
    &:before {
      content: "";
      height: 1px;
      width: 100%;
      background: ${Color.greySeparator};
      display: block;
      margin: 3px 0;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          background: ${ColorDark.greySeparator};
        }
      }
    }
    &:after {
      content: "";
      height: 1px;
      width: 100%;
      background: ${Color.greySeparator};
      display: block;
      margin-top: 5px;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          background: ${ColorDark.greySeparator};
        }
      }
    }
  }
  .commentary-title {
    padding: 10px 15px 8px;
    ${Font.sansRegular};
    text-align: left;
    font-size: 22px;
    color: ${Color.secondaryBlack};
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 8px;
    border-bottom: 1px solid ${Color.greySeparator};

    ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
    ${breakpoints.phone} {
      font-size: 18px;
      padding-left: 10px;
    }
    span {

      color: ${Color.mainColor};
      ${Font.clarinVarSub2Bold};
      margin-top: -1px;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.mainColor};
        }
      }
    }
    .commentary-icon::before {
      content: "";
      display: block;
      background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iNiIgZmlsbD0iIzk0QkUxRiIvPgo8Y2lyY2xlIGN4PSIxMSIgY3k9IjExIiByPSIxMC41IiBzdHJva2U9IiM5NEJFMUYiLz4KPC9zdmc+Cg==);
      width: 22px;
      height: 22px;
      margin-top: -5px;
      ${breakpoints.phone} {
        margin-right: 6px;
      }
    }
  }
  .timeline {
    position: relative;
    padding-left: 26px;
    margin-top: 20px;
    ${breakpoints.phone} {
      padding-left: 20px;
    }
  }

  .comment {
    padding: 10px 10px 30px 40px;
    position: relative;
    border-left: 1px solid transparent;
    border-image: repeating-linear-gradient(
      to bottom,
      rgb(129, 129, 129) 0,
      rgb(129, 129, 129) 3px,
      transparent 1px,
      transparent 5px
    );
    border-image-slice: 1;
    color: rgb(80, 79, 79);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 8px;
    ${breakpoints.phone} {
      padding-left: 20px;
      padding-right: 5px;
    }

    .highlight-overlay {
      position: absolute;
      top: 10px;
      left: 0;
      width: 100%;
      height: 80%;
      background: rgba(188, 159, 118, 0.2);
      z-index: 1;

      ${breakpoints.phone} {
        height: 85%;
      }
    }
    .time-group {
      display: flex;
      flex-direction: row;
      align-items: center;
      border: 1.5px solid ${Color.grey};
      padding: 6px 10px 6px 12px;
      border-radius: 16px;
      column-gap: 5px;
      ${Font.clarinVarSub2Bold};
      color: ${Color.grey};
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }

      ${breakpoints.phone} {
        padding: 6px 8px 6px;
        flex-wrap: wrap;
        border-radius: 14px;
      }
      .minute,
      .event-name {
        ${Font.clarinVarSub2ExtraBold};
        letter-spacing: 0.5px;
        color: ${Color.grey};
        font-size: 16px;
        ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
        ${breakpoints.phone} {
          font-size: 12px;
        }
      }

      img {
        width: revert-layer;        
        ${breakpoints.phone} {
         width: 15px;
         height: auto;

        }
      }
    }

    .event-detail {
      ${Font.clarinVarSub2Regular};
      color: ${Color.grey666};
      font-size: 16px;
      line-height: 22px;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
      ${breakpoints.phone} {
        font-size: 14px;
        line-height: 22px;
      }
      ::before {
        content: "";
        position: absolute;
        left: -8px;
        top: 20px;
        width: 18px;
        height: 18px;
        background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNyIgY3k9IjciIHI9IjYuNSIgZmlsbD0id2hpdGUiIHN0cm9rZT0iI0NDMDAxQiIvPgo8Y2lyY2xlIGN4PSI3IiBjeT0iNyIgcj0iNCIgZmlsbD0iI0NDMDAxQiIvPgo8L3N2Zz4K);
        background-repeat: no-repeat;
        z-index: 10;
      }
      ::after {
        content: "";
        display: block;
        width: 55px;
        height: 1px;
        background-color: ${Color.mainColor};
        position: absolute;
        bottom: 15px;
        left: 40px;
        z-index: 5;
        ${breakpoints.phone} {
          left: 20px;
      }
      }
    }
  }

  .highlight {
    padding-top: 20px;
    padding-bottom: 45px;
    .time-group {
      background-color: ${Color.grey};
      color: white;
      z-index: 3;
      .event-name,
      .minute {
        color: white;
      }
    }
    .event-detail {
      z-index: 3;
      ::before {
        top: 30px;
      }
      ::after {
        display: none;
      }
    }
  }
`;
